import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-show',
	templateUrl: './icon-show.component.svg',
})
export class IconShowComponent {}
